import { useContext } from 'react';
import { ClientSettingsProvider } from '../context';

export default function useClientSettings() {
    const clientSettings = useContext(ClientSettingsProvider.Context);

    if (!clientSettings) {
        throw new Error('Client settings not found.');
    }

    return clientSettings;
}
